module.exports = __webpack_public_path__ + "img/logo-black.f9b11591.svg";